// frontend/src/components/billing/billingOffered.js
//
// Whether the selected store has billing settings (the Plans screen): Shopify
// stores only. Read by the user menu (layout/navMenus.userMenu), which the
// desktop user dropdown and the phone's More sheet both list.

/** @param {object | null} store  the selected store, or null when none is. */
export function billingOffered(store) {
  return store?.store_type === 'shopify';
}
